import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux"
import { setActiveStep, createTicketBooking } from "../../../../app/store/slices/ticket/ticketBuying"
import { errorToast } from "../../../../utils/toasts/toasts"

export default function useTicketListing(eventData) {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { selectedTickets, totalTickets } = useSelector(state => state.ticketBuying);

    const [loading, setLoading] = useState(false)
    const [openModal, setOpenModal] = useState(false);
    const [modalVariant, setModalVariant] = useState("eventDrafted"); // "eventCancelled" | "eventDrafted"

    const ticketData = eventData?.tickets || [];


    // TODO: Add the logic to set the modal variant based on the error received from backend in catch block
    /**
     * @async
     * @function handleProceed
     * @description Handles the proceed action to create a ticket booking and navigate to the attendee step.
     * @returns {Promise<void>}
     * 
     * Steps:
     * 1. Clear "continuedBooking" from localStorage to ensure a fresh booking process.
     * 2. Set loading state to true to indicate the process has started.
     * 3. Prepare booking data including event ID, user ID, and selected tickets with their quantities.
     * 4. Dispatch the createTicketBooking action with the prepared booking data.
     * 5. On successful booking creation, dispatch setActiveStep to move to the 'attendee' step.
     * 6. Handle errors by displaying appropriate error toasts based on the error code.
     * 7. Finally, set loading state back to false to indicate the process has completed.
     */
    async function handleProceed() {
        try {

            localStorage.removeItem("continuedBooking");

            setLoading(true);

            const bookingData = {
                event_id: eventData?.eventId,
                user_id: eventData?.user_id,
                tickets: selectedTickets?.map(ticket => ({
                    ticket_type_id: ticket?.ticketId,
                    quantity: ticket?.quantity
                })) || []
            }

            await dispatch(createTicketBooking({ bookingData, eventId: eventData?.eventId })).unwrap();

            dispatch(setActiveStep('attendee'))
        } catch (error) {

            // Handle specific error scenarios
            if (error?.code === 400) {
                // Check if event is cancelled or drafted

                if (error?.message === 'cancelled') {
                    setModalVariant('eventCancelled');
                    setOpenModal(true);
                } else if (error?.message === 'drafted') {
                    setModalVariant('eventDrafted');
                    setOpenModal(true);
                } else {
                    errorToast(error?.statusText || "Bad Request");
                }
                
            } else if (error?.code === 404) {
                errorToast(error?.statusText || "Resource not found");
            } else if (error?.code === 500) {
                errorToast(error?.statusText || "Server error occurred");
            } else {
                errorToast(error?.statusText || "An unexpected error occurred.");
            }

        } finally {
            setLoading(false);
        }
    }

    
    function goToEventPage() {
        setOpenModal(false);
        navigate(`/events`);
    }

    return {
        handleProceed,
        loading,
        ticketData,
        totalTickets,
        selectedTickets,
        openModal,
        setOpenModal,
        modalVariant,
        goToEventPage
    }
}